import { alertManualEndpoints as alertManual } from 'api/endpoints/alertManual'
import { authEndpoints as auth } from 'api/endpoints/auth'
import { cfrDefaultParamsEndpoints as cfrDefaultParams } from 'api/endpoints/cfrDefaultParams'
import { cfrGroupsEndpoints as cfrGroups } from 'api/endpoints/cfrGroups'
import { cfrLogsEndpoints as cfrLogs } from 'api/endpoints/cfrLogs'
import { cognitiveSettingsEndpoints as cognitiveSettings } from 'api/endpoints/cognitiveSettings'
import { configEndpoints as config } from 'api/endpoints/config'
import { dataSourceFieldsEndpoints as dataSourceFields } from 'api/endpoints/dataSourceFields'
import { granularitiesEndpoints as granularities } from 'api/endpoints/granularities'
import { groupsEndpoints as groups } from 'api/endpoints/groups'
import { languagesEndpoints as languages } from 'api/endpoints/languages'
import { manualsEndpoints as manuals } from 'api/endpoints/manuals'
import { mlSettingsEndpoints as mlSettings } from 'api/endpoints/mlSettings'
import { projectMlEndpoints as projectMl } from 'api/endpoints/projectMl'
import { projectsEndpoints as projects } from 'api/endpoints/projects'
import { promoGroupsEndpoints as promoGroups } from 'api/endpoints/promoGroups'
import { promoLogsEndpoints as promoLogs } from 'api/endpoints/promoLogs'
import { promoOptimizerSettingsEndpoints as promoOptimizerSettings } from 'api/endpoints/promoOptimizerSettings'
import { promoPeriodsEndpoints as promoPeriods } from 'api/endpoints/promoPeriods'
import { promoSettingsEndpoints as promoSettings } from 'api/endpoints/promoSettings'
import { pythonTypesEndpoints as pythonTypes } from 'api/endpoints/pythonTypes'
import { rtmGroupsEndpoints as rtmGroups } from 'api/endpoints/rtmGroups'
import { rtmParametersEndpoints as rtmParameters } from 'api/endpoints/rtmParameters'
import { templatesEndpoints as templates } from 'api/endpoints/templates'
import { tetrisDefaultPricesEndpoints as tetrisDefaultPrices } from 'api/endpoints/tetrisDefaultPrices'
import { tetrisGroupsEndpoints as tetrisGroups } from 'api/endpoints/tetrisGroups'
import { tetrisLogsEndpoints as tetrisLogs } from 'api/endpoints/tetrisLogs'
import { usersEndpoints as users } from 'api/endpoints/users'

export const endpoints = {
  auth,
  dataSourceFields,
  users,
  groups,
  projects,
  projectMl,
  granularities,
  templates,
  promoGroups,
  promoLogs,
  promoOptimizerSettings,
  promoPeriods,
  promoSettings,
  pythonTypes,
  languages,
  mlSettings,
  cognitiveSettings,
  rtmGroups,
  rtmParameters,
  tetrisGroups,
  tetrisDefaultPrices,
  tetrisLogs,
  cfrGroups,
  cfrDefaultParams,
  config,
  cfrLogs,
  manuals,
  alertManual,
}
